import React, { useState, useEffect } from 'react';
import { inventoryService } from '../../services/inventoryService';
import { FiPlus, FiEdit, FiTrash2, FiTag } from 'react-icons/fi';

const CategoryList = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editingCategory, setEditingCategory] = useState(null);
  const [formData, setFormData] = useState({ name: '' });

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    setLoading(true);
    try {
      const data = await inventoryService.getCategories();
      setCategories(data || []);
    } catch (error) {
      console.error('Error loading categories:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name.trim()) {
      alert('Nama kategori wajib diisi');
      return;
    }

    try {
      if (editingCategory) {
        await inventoryService.updateCategory(editingCategory.id, formData);
      } else {
        await inventoryService.createCategory(formData);
      }
      setShowForm(false);
      setEditingCategory(null);
      setFormData({ name: '' });
      await loadData();
    } catch (error) {
      alert('Error: ' + error.message);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Hapus kategori ini? Data inventory dengan kategori ini akan kehilangan kategori.')) {
      try {
        await inventoryService.deleteCategory(id);
        await loadData();
      } catch (error) {
        alert('Error: ' + error.message);
      }
    }
  };

  const handleEdit = (category) => {
    setEditingCategory(category);
    setFormData({ name: category.name || '' });
    setShowForm(true);
  };

  if (loading) {
    return <div className="text-center py-8">Loading...</div>;
  }

  return (
    <div>
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-bold">Kategori Inventory</h2>
        <button
          onClick={() => {
            setEditingCategory(null);
            setFormData({ name: '' });
            setShowForm(true);
          }}
          className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
        >
          <FiPlus /> Tambah Kategori
        </button>
      </div>

      {/* Form */}
      {showForm && (
        <div className="bg-[var(--bg-secondary)] p-4 rounded-lg mb-4">
          <form onSubmit={handleSubmit} className="flex gap-3 items-end">
            <div className="flex-1">
              <label className="block text-sm font-medium text-[var(--text-secondary)] mb-1">
                Nama Kategori *
              </label>
              <input
                type="text"
                placeholder="Contoh: Bahan Baku"
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                className="w-full px-3 py-2 border border-[var(--border-color)] rounded-lg bg-[var(--bg-primary)] text-[var(--text-primary)] focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
              />
            </div>
            <div className="flex gap-2">
              <button type="submit" className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700">
                {editingCategory ? 'Update' : 'Simpan'}
              </button>
              <button
                type="button"
                onClick={() => { setShowForm(false); setEditingCategory(null); }}
                className="px-4 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600"
              >
                Batal
              </button>
            </div>
          </form>
        </div>
      )}

      {/* List */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {categories.length === 0 ? (
          <div className="col-span-full text-center py-8 text-[var(--text-secondary)]">
            <FiTag size={48} className="mx-auto mb-2 opacity-50" />
            <p>Belum ada kategori</p>
            <p className="text-sm">Klik "Tambah Kategori" untuk membuat</p>
          </div>
        ) : (
          categories.map((cat) => (
            <div key={cat.id} className="bg-[var(--bg-primary)] p-4 rounded-lg shadow-[var(--shadow-sm)] border border-[var(--border-color)] hover:shadow-[var(--shadow-md)] transition-shadow">
              <div className="flex justify-between items-center">
                <div className="flex items-center gap-3">
                  <FiTag size={20} className="text-blue-500" />
                  <span className="font-medium text-[var(--text-primary)]">{cat.name}</span>
                </div>
                <div className="flex gap-2">
                  <button onClick={() => handleEdit(cat)} className="text-yellow-600 hover:text-yellow-800 transition-colors" title="Edit">
                    <FiEdit size={18} />
                  </button>
                  <button onClick={() => handleDelete(cat.id)} className="text-red-600 hover:text-red-800 transition-colors" title="Delete">
                    <FiTrash2 size={18} />
                  </button>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default CategoryList;